import { LegalTextGoogleForDisplayFooter } from 'components/Stage/LegalText';

/**
 * This component is a placeholder for the LegalText component to be able to link it via Contentful.
 */
export function LegalTextGoogleFooterLink() {
  return <LegalTextGoogleForDisplayFooter />;
}
